// Fires a GA4 pageview every time React Router's location changes.
// Mounted once inside <BrowserRouter>, has no UI.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;
